import React from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

interface BatchMatrixLandscapeOverlayProps {
  open: boolean;
  overlayRef: React.RefObject<HTMLDivElement>;
  onClose: () => void;
  children: React.ReactNode;
}

/** Landscape fullscreen shell for the batch-compare metrics table (PWA). */
export function BatchMatrixLandscapeOverlay({
  open,
  overlayRef,
  onClose,
  children,
}: BatchMatrixLandscapeOverlayProps) {
  const { t } = useTranslation();

  if (!open) return null;

  return createPortal(
    <div
      ref={overlayRef}
      className="pdc-fullscreen-overlay cmp-batch-fs mobile-fullscreen-panel vo2-slide-up-fullscreen"
    >
      <header className="pdc-fullscreen-overlay__header">
        <button
          type="button"
          className="pdc-fullscreen-overlay__close pdc-chart__icon-btn"
          onClick={() => void onClose()}
          aria-label={t('pdcChart.close')}
        >
          ×
        </button>
        <h2 className="pdc-fullscreen-overlay__title">{t('compare.batch.matrixTitle')}</h2>
        <span className="pdc-fullscreen-overlay__spacer" aria-hidden />
      </header>
      <p className="pdc-fullscreen-overlay__hint">{t('pdcChart.rotateHint')}</p>
      <div className="pdc-fullscreen-overlay__body cmp-batch-fs__body">
        <div className="cmp-batch__matrix-scroll cmp-batch__matrix-scroll--fullscreen">{children}</div>
      </div>
    </div>,
    document.body,
  );
}
